import {Component, Input, OnInit} from '@angular/core';
import {TemplateComponent} from "../../template/template.component";
import {NgIf} from "@angular/common";

@Component({
  selector: 'app-page-list-item',
  standalone: true,
  imports: [
    NgIf
  ],
  templateUrl: './page-list-item.component.html',
  styleUrl: './page-list-item.component.css'
})
export class PageListItemComponent extends TemplateComponent implements OnInit {
  @Input() bgColor: string = "#ffffff";
  @Input() text: string = "";
  @Input() logoSrc: string = "";
  @Input() imgSrc: string="";
  @Input() uid: string="";
  @Input() title: string="";
  @Input() pageType="PAGE";


  ngOnInit() {

  }

  goToPage(pageuid: String) {
    if(this.pageType=="SUCCESS_STORY"){
      this.route.navigate(["/success_story/"+pageuid])
    }else if(this.pageType=="PAGE"){
      this.route.navigate(["/page/"+pageuid])
    }else if(this.pageType=="FEATURE"){
      this.route.navigate(["/feature/"+pageuid])
    }else if(this.pageType=="BLOG"){
      this.route.navigate(["/blog/"+pageuid])
    }else if(this.pageType=="NEWS"){
      this.route.navigate(["/news/"+pageuid])
    }else if(this.pageType=="CUSTOMER"){
      this.route.navigate(["/customer/"+pageuid])
    }

  }

}
